<template>
  <component v-bind="containerTag.props" :is="containerTag.name">
    <slot name="before-name" />
    <component
      v-bind="{ ...parrierTag.props, ...(customBind.name || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-bind="{ ...(customBind.nameInput || {}), ...textFieldProps }"
        v-model="input.name"
        placeholder="App Name"
      />
    </component>
    <slot v-if="!put" name="before-culture" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.culture || {}) }"
      :is="parrierTag.name"
    >
      <v-select
        v-bind="{ ...(customBind.cultureInput || {}), ...textFieldProps }"
        v-model="input.culture"
        :items="[
          { text: 'English', value: 'en-US' },
          { text: 'Arabic', value: 'ar-AR' },
        ]"
        item-text="text"
        item-value="value"
        placeholder="App Culture"
      />
    </component>
    <slot v-if="!put" name="before-disc" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.disc || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-bind="{ ...(customBind.discInput || {}), ...textFieldProps }"
        v-model="input.description"
        placeholder="App Description"
      />
    </component>
    <slot name="before-priority" />
    <component
      v-bind="{ ...parrierTag.props, ...(customBind.priority || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-bind="{ ...(customBind.priorityInput || {}), ...textFieldProps }"
        v-model="input.priority"
        :min="0"
        type="number"
        placeholder="App Priority"
      />
    </component>
    <slot
      v-if="!put || (putClone && putClone.app_type === 'luis')"
      name="before-nlu"
    />
    <component
      v-if="!put || (putClone && putClone.app_type === 'luis')"
      v-bind="{ ...parrierTag.props, ...(customBind.nlu || {}) }"
      :is="parrierTag.name"
    >
      <v-select
        v-bind="{ ...(customBind.nluInput || {}), ...textFieldProps }"
        :items="[
          { text: 'BOTTER', value: 'rasa' },
          { text: 'LUIS', value: 'luis' },
          { text: 'Shared', value: 'shared' },
        ]"
        item-value="value"
        item-text="text"
        v-model="input.app_type"
        placeholder="NLU Engine"
      />
    </component>
    <slot name="before-token" v-if="input.app_type === 'shared'" />
    <component
      v-if="input.app_type === 'shared'"
      v-bind="{ ...parrierTag.props, ...(customBind.nlu || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-bind="{ ...(customBind.nameInput || {}), ...textFieldProps }"
        v-model="envToken"
        placeholder="Token"
      />
    </component>
    <slot name="before-confidence" />
    <component
      v-bind="{ ...parrierTag.props, ...(customBind.confidence || {}) }"
      :is="parrierTag.name"
    >
      <v-slider
        v-bind="{ ...(customBind.confidenceInput || {}), ...textFieldProps }"
        v-model="input.min_score"
        :max="1"
        :min="0.1"
        :step="0.1"
        thumb-label
      />
    </component>
    <slot v-for="(slot, s) in new Array(slots)" :name="`tail-slot-${s + 1}`" />
  </component>
</template>

<script>
export default {
  name: "AddApp",
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true,
        };
      },
    },
    slots: {
      type: Number,
      default: 2,
    },
    customBind: {
      type: Object,
      default() {
        return {};
      },
    },
    put: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isValid: false,
      putClone: null,
      envToken: "",
      input: {
        name: "",
        description: "",
        culture: "en-us",
        min_score: 0.1,
        priority: 2,
        app_type: "luis",
      },
    };
  },
  watch: {
    put(val) {
      if (val) {
        this.input = val;
        this.putClone = this.$_.cloneDeep(val);
      } else this.resetForm();
    },
  },
  methods: {
    async submit() {
      try {
        if (this.input.name.length) {
          this.emitLoading(true);
          const payload = this.put
            ? { ...this.input, id: this.put.id }
            : { ...this.input, bot_id: this.$store.state.bot.botId };
          payload.priority = parseInt(this.input.priority, 10);
          if (this.input.app_type === "shared") {
            payload.shared = {
              appId: this.input.culture === "en-US" ? 147 : 150,
              baseUrl: "https://nlp.staging.botter.live",
              token: this.envToken,
            };
          }
          const response = await this.$store.dispatch(
            `nlp/apps/${this.put ? "update" : "add"}`,
            payload
          );

          this.resetForm();
          this.emitLoading(false);
          this.$emit("success", response.data);
        }
      } catch (error) {
        this.emitLoading(false);
        throw error;
      }
    },
    async resetForm() {
      this.input = {
        name: "",
        description: "",
        culture: "en-us",
        min_score: 0.1,
        priority: 2,
        app_type: "luis",
      };

      return true;
    },
    emitLoading(status = true) {
      this.$emit("loading", status);
    },
  },
};
</script>

<style lang="css" scoped></style>
